"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../utils");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Paragraph = function Paragraph(props) {
  var paragraphCss = (0, _utils.createCssClassByProps)(props);
  var text = props.text;
  text = {
    __html: text
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
    className: paragraphCss,
    dangerouslySetInnerHTML: text
  });
};

Paragraph.propTypes = {
  /**
   * {
   *  "info": "Establece el texto que aparecerá dentro del componente",
   *  "kind": "both",
   *  "beautifulName": "Texto"
   * }
   */
  text: _propTypes["default"].string.isRequired,

  /**
   * {
   *  "info": "Establece el color del componente",
   *  "kind": "both",
   *  "beautifulName": "Color"
   * }
   */
  color: _propTypes["default"].string,

  /**
   * {
   *  "info": "Establece el tamaño de letra del componente",
   *  "kind": "both",
   *  "beautifulName": "Tamaño"
   * }
   */
  size: _propTypes["default"].string,

  /**
   * {
   *  "info": "Establece el tipo de fuente del componente",
   *  "kind": "both",
   *  "beautifulName": "Texto"
   * }
   */
  fontType: _propTypes["default"].string,

  /**
   * {
   *  "info": "Establece el tipo de texto del componente",
   *  "kind": "both",
   *  "beautifulName": "Tipo"
   * }
   */
  kind: _propTypes["default"].string,

  /**
   * {
   *  "info": "Establece el alineamiento del texto del componente",
   *  "kind": "both",
   *  "beautifulName": "Alineamiento"
   * }
   */
  align: _propTypes["default"].string,

  /**
   * {
   *  "info": "Define la clase CSS custom que se aplicará al componente",
   *  "kind": "both",
   *  "beautifulName": "Estilos custom"
   * }
   */
  className: _propTypes["default"].string,

  /**
   * {
   *  "info": "Define el comportamiento del componente dentro del DOM",
   *  "kind": "both",
   *  "beautifulName": "Display"
   * }
   */
  display: _propTypes["default"].string
};
var _default = Paragraph;
exports["default"] = _default;

//# sourceMappingURL=index.js.map